// Mirrors libvinnie.constants.CISA_SECTORS — the 16 CISA Critical
// Infrastructure Sectors, as slugs stored in products.prevalence_json,
// with Government Facilities split into US vs. non-US.
export const CISA_SECTORS = {
  chemical: "Chemical",
  commercial_facilities: "Commercial Facilities",
  communications: "Communications",
  critical_manufacturing: "Critical Manufacturing",
  dams: "Dams",
  defense_industrial_base: "Defense Industrial Base",
  emergency_services: "Emergency Services",
  energy: "Energy",
  financial_services: "Financial Services",
  food_and_agriculture: "Food and Agriculture",
  us_government: "US Government (Federal, State, Local, Tribal, and Territorial)",
  non_us_government: "Non-US Government",
  healthcare_public_health: "Healthcare and Public Health",
  information_technology: "Information Technology",
  nuclear: "Nuclear Reactors, Materials, and Waste",
  transportation_systems: "Transportation Systems",
  water_wastewater_systems: "Water and Wastewater Systems",
};

// One emoji per sector, for the badges. Sector badges are abbreviated to fit
// (the first word of the name, alongside a level), so a whole column of them
// reads as near-identical text at 10px — the glyph is what makes a row
// scannable at a glance. Purely decorative: every badge still carries the
// sector name as text and the full name in its tooltip, so these are marked
// aria-hidden at the call site rather than standing in for a label.
//
// Dams gets the wave and water/wastewater the droplet: the two are the
// easiest pair to confuse, and they need to differ at badge size.
export const SECTOR_EMOJI = {
  chemical: "🧪",
  commercial_facilities: "🏬",
  communications: "📡",
  critical_manufacturing: "🏭",
  dams: "🌊",
  defense_industrial_base: "🛡️",
  emergency_services: "🚨",
  energy: "⚡",
  financial_services: "🏦",
  food_and_agriculture: "🌾",
  us_government: "🏛️",
  non_us_government: "🌐",
  healthcare_public_health: "🏥",
  information_technology: "💻",
  nuclear: "☢️",
  transportation_systems: "🚆",
  water_wastewater_systems: "💧",
};
